import { CurrencyDto } from "app/data/management/models/currency.dto";
import { ShippingAddressDto } from "app/modules/dashboard/modules/finance-management/shipping-address/model/shipping-address.dto";
import { BaseDto } from "@app/modules/shared/model/base.dto";
import { CurrentAccountDto } from "@dashboard/modules/finance-management/current-account/model/current-account.dto";

export class BillingDto extends BaseDto {
  public document_type?: string;
  public type?: string;
  public branch?: any;
  public dest_branch?: any;
  public company?: any;
  public working_period?: any;
  public currency?: CurrencyDto;
  public current_account?: CurrentAccountDto;
  public discount_amount?: number; // indirim tutari
  public document_date_lc?: any;
  public document_date?: any;
  public document_num?: string;
  public document_time?: string;
  public exchange_rate?: number;
  public expense_amount?: number;
  public external_document_num?: string;
  public invoiced?: string;
  public gross_total_amount?: number;
  public line_discount_amount?: number;
  public line_expense_amount?: number;
  public lines?: any;
  public discounts?: any;
  public from_dispatch?: boolean;
  public net_total_amount?: number; // net toplam
  public payment_plan?: any;
  public sales_person?: any;
  public shipment_address?: ShippingAddressDto;
  public special_code?: string;
  public status?: string;
  public vat_amount?: number;
  public without_vat_amount?: number; // kdvsiz (toplam) tutar
  public warehouse?: any;
  public dest_warehouse?: any;
  public purchase_invoice?: any;
  public sales_invoice?: any;
  public purchase_dispatches?: Array<any>;
  public sales_dispatches?: Array<any>;
}
